import { CheckIcon } from "@heroicons/react/24/solid";
import { cn } from "../../lib/utils";

export default function Checkbox({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange?: (checked: boolean) => void;
}) {
  return (
    <div>
      <div
        className={cn(
          "w-6 h-6 border border-secondary bg-dark rounded-sm flex items-center justify-center cursor-pointer ",
          checked && "bg-primary",
          !checked && "hover:bg-primary/10"
        )}
        onClick={() => onChange?.(!checked)}
      >
        {checked ? <CheckIcon className="w-4 h-4 text-dark" /> : null}
      </div>
    </div>
  );
}
